import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User, Crown } from "lucide-react";
import { motion } from "framer-motion";

const ProfileSection = ({ user, isPremium }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
    <Card className="glass">
      <CardHeader>
        <CardTitle className="text-lg text-white flex items-center gap-2">
          <User className="w-5 h-5" />
          Profile
          {isPremium && (
            <Badge className="bg-moon-gold/20 text-moon-gold ml-2">
              <Crown className="w-3 h-3 mr-1" /> Premium
            </Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center gap-4">
          {user?.picture ? (
            <img src={user.picture} alt={user.name} className="w-16 h-16 rounded-full" />
          ) : (
            <div className="w-16 h-16 rounded-full bg-mystic-700 flex items-center justify-center">
              <User className="w-8 h-8 text-mystic-300" />
            </div>
          )}
          <div>
            <p className="text-white font-medium">{user?.name}</p>
            <p className="text-mystic-200/70 text-sm">{user?.email}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  </motion.div>
);

export default ProfileSection;
